import { render } from "./CommodityInfo.vue?vue&type=template&id=db97e6ac&scoped=true"
import script from "./CommodityInfo.vue?vue&type=script&lang=js"
export * from "./CommodityInfo.vue?vue&type=script&lang=js"

import "./CommodityInfo.vue?vue&type=style&index=0&id=db97e6ac&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db97e6ac"]])

export default __exports__